import React from 'react';
import PageHeader from '../components/PageHeader';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Resources = () => {
  const articles = [
    { title: 'EAP vs ERP vs BCP vs EOP', icon: FiIcons.FiFileText },
    { title: 'How to Keep Emergency Plans Current', icon: FiIcons.FiRefreshCw },
    { title: 'How to Plan a Tabletop Exercise', icon: FiIcons.FiUsers },
    { title: 'How to Coordinate with Local Responders', icon: FiIcons.FiRadio },
    { title: 'How to Measure Emergency-Preparedness ROI', icon: FiIcons.FiTrendingUp },
    { title: 'NFPA 70E Field Application', icon: FiIcons.FiZap },
    { title: 'Hazardous-Materials Compliance for Small Businesses', icon: FiIcons.FiAlertTriangle },
    { title: 'Training a Changing and Multi-Generational Workforce', icon: FiIcons.FiUsers },
    { title: 'Emotional Intelligence in Safety Interventions', icon: FiIcons.FiHeart },
    { title: 'AI Risks and Safe Workplace Adoption', icon: FiIcons.FiCpu },
    { title: 'Corrective-Action Tracking After Exercises', icon: FiIcons.FiCheckSquare },
    { title: 'Emergency Operations Center Activation', icon: FiIcons.FiMonitor }
  ];

  return (
    <div className="w-full bg-brand-light min-h-screen">
      <PageHeader 
        title="Resource Library" 
        description="Practical guides, articles, checklists, and capability statements." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          
          {/* Main Content */}
          <div className="lg:col-span-8">
            <h2 className="text-2xl font-bold text-brand-navy mb-8 flex items-center gap-3">
              <SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-green" /> Articles & Guides
            </h2>
            <div className="space-y-4">
              {articles.map((article, i) => (
                <a key={i} href="#" className="flex items-center gap-5 p-5 bg-white border border-slate-200 rounded-xl hover:border-brand-green hover:shadow-md transition-all group">
                  <div className="w-12 h-12 rounded-lg bg-brand-light text-brand-navy flex items-center justify-center shrink-0 group-hover:bg-brand-navy group-hover:text-white transition-colors">
                    <SafeIcon icon={article.icon} className="text-xl" />
                  </div>
                  <div className="flex-grow">
                    <h3 className="text-lg font-bold text-slate-800 group-hover:text-brand-navy transition-colors">{article.title}</h3>
                  </div>
                  <div className="shrink-0 text-brand-green">
                    <SafeIcon icon={FiIcons.FiArrowRight} />
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4">
            <div className="bg-brand-navy rounded-2xl p-8 text-white sticky top-28 shadow-xl">
              <div className="w-14 h-14 bg-white/10 rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={FiIcons.FiDownload} className="text-2xl text-brand-green" />
              </div>
              <h3 className="text-xl font-bold mb-4">Capability Statement</h3>
              <p className="text-slate-300 text-sm mb-8 leading-relaxed font-medium">
                Download our official capability statement containing company data, NAICS codes, core competencies, and past performance summaries.
              </p>
              <button className="w-full py-3 bg-brand-green text-white font-bold rounded-xl hover:bg-green-600 transition-colors shadow-lg flex items-center justify-center gap-2">
                <SafeIcon icon={FiIcons.FiFileText} /> Download PDF
              </button>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Resources;